import React from 'react'
import styled, { keyframes } from 'styled-components'
import { colors } from '../styles/vars'
const rotate360 = keyframes`
0% { transform: rotate(0deg); }
100% { transform: rotate(360deg); }
`

const StyledLoader = styled.div`
border: 8px solid ${colors.black};
border-top-color: ${colors.purple};
border-radius: 50%;
width: 60px;
height: 60px;
animation: ${rotate360} 1.3s linear infinite;
will-change: transform;
backface-visibility: hidden;
margin: auto;
position:absolute;
top:0;
bottom:0;
left:0;
right:0;
display:${props => props.active ? 'block' : 'none'};
`
const Loader = (props) => {
    return (
        <StyledLoader active={props.isActive} />
    );
}

export default Loader;


// WEBPACK FOOTER //
// ./src/components/Loader.jsx